/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'

export type HeroProps = {
  children: React.ReactNode
}

export const HeroContainer = ({ children }: HeroProps) => {
  return <div css={heroContainerStyle}>{children}</div>
}

const heroContainerStyle = css`
  position: relative;
`

export type ImageListProps = {
  children: React.ReactNode
}

export const ImageList = ({ children }: ImageListProps) => {
  return <div css={imageListStyle}>{children}</div>
}

const imageListStyle = css`
  position: absolute;
  bottom: 15px;
  left: 15px;
  display: grid;
  grid-auto-flow: column;
  column-gap: 10px;
`
